var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found-container"},[_c('h2',{staticClass:"not-found-message"},[_vm._v(" 404: The page you are looking for does not exist ")])])
}]

export { render, staticRenderFns }